import HomeImg1 from "../assets/img/logo_3.png"
import HomeImg2 from "../assets/img/logo_2.png"
import HomeShadow from "../assets/img/logo_4.png"
import EthLogo from "../assets/img/Ethereum_logo.png"
import Logo5 from "../assets/img/logo_5.png"
import BtcLogo from "../assets/img/btc_ico.png"
import ClsLogo from "../assets/img/cls.png"

export default function HeaderSection(props) {
    const { account } = props;

    return (
        <div className="relative bg-[url('./assets/img/back.png')] bg-cover bg-center min-h-[220px] sm:min-h-[280px] lg:h-[380px] w-full py-8 sm:py-10 overflow-hidden">
            <div className="hidden xl:flex pointer-events-none">
                <img src={HomeShadow} alt="shadow" className='absolute top-[105px] right-[95px]' />
                <img src={HomeImg2} alt={"home1"} className="absolute top-[105px] right-[422px]" />
                <img src={HomeImg1} alt={"home2"} className="absolute top-[105px] right-[0px]" />
                <img src={EthLogo} alt={"eth"} className="absolute top-[250px] right-[541px]" />
                <img src={Logo5} alt={"logo"} className="absolute top-[140px] right-[182px]" />
                <img src={ClsLogo} alt={"logo"} className="absolute top-[335px] right-[520px]" />
                <img src={BtcLogo} alt={"logo"} className="absolute top-[335px] right-[520px]" />
            </div>
            <div className="flex flex-row items-center h-full">
                <div className="px-4 sm:px-8 lg:ml-[170px] lg:px-0 max-w-full">
                    <p className="max-w-full tracking-wide sm:tracking-widest text-[#fff] text-[28px] sm:text-[44px] lg:text-[60px] font-Inter-Bold leading-tight">
                        {account === false ? "FLASH DEAD" : "ACCOUNT PAGE"}
                    </p>
                    <p className="max-w-[520px] text-[#fff] text-[14px] sm:text-[16px] font-Inter-Regular mt-3">
                        {account === false
                            ? "1st Dapps in the decentralized world to easily transfer your funds to your heirs. Flash Dead website is a directory to see your wills and wallets to claim."
                            : "Configure and view your profile"}
                    </p>
                </div>
            </div>
        </div>
    )
}
